import { partialRight } from 'lodash-es';
import { onCartTrackEvent } from './onCartTrackEvent';
import { onCartItemCountUpdate } from './onCartItemCountUpdate';
import onLogError from '../../../utils/onLogError';

const cartPageEvent = {
  onTrackEvent: onCartTrackEvent,
  onCartItemCountUpdate: onCartItemCountUpdate,
  onLogError: partialRight(onLogError, (scope) => {
    scope.setTag('module', 'sl-checkout-module');
  }),
};

export default cartPageEvent;
